// --------------------------------------------------------------
// Created On: 2024-04-29
// Author: Zachary Thomas
//
// Last Modified: 2024-10-11
// Modified By: Zachary Thomas
//
// Copyright 2024 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// These scripts can be injected into SVGs to replace existing script logic.
export const BOM_SVG_SCRIPT = `
  function ShowPaper(){}

  function ShowToolTip(evt, hotspotid, strTooltip){
    const hoveredPart = document.getElementById("bom-svg-hovered-part")
    if(hoveredPart !== null) {
      hoveredPart.innerHTML = strTooltip;
    }
  }

  function ShowHotSpot(evt, hotspotid) {
    const svgDocument = evt.target.ownerDocument;
    const strId = "hotspot."+hotspotid;
    const hotspot = svgDocument.getElementById(strId);
    if (hotspot !== null) {
      hotspot.setAttribute("opacity",".5");
    }
  }

  function HideHotSpot(evt, hotspotid) {
    const svgDocument = evt.target.ownerDocument;
    const strId = "hotspot."+hotspotid;
    const hotspot = svgDocument.getElementById(strId);
    if (hotspot !== null) {
      hotspot.setAttribute("opacity","0");
    }
    const hoveredPart = document.getElementById("bom-svg-hovered-part")
    if(hoveredPart !== null) {
      hoveredPart.innerHTML = "";
    }
  }
  `;
